import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {getUrlParameters} from '../../common/util/urlParameters';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const loadAccessoriesOrders = (params = {}, editGenerate = true) => apiActionCreator({
  'endpoint': `/accessories/orders${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.LOADING_ACCESSORIES_ORDERS,
    {
      'type': ActionTypes.LOADED_ACCESSORIES_ORDERS,
      'payload': editGenerate,
    },
    [
      ActionTypes.LOADED_ACCESSORIES_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const generateAccessoriesOrders = (data = {}, params = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/accessories/orders',
      'authenticated': true,
      'types': [
        ActionTypes.GENERATING_ACCESSORIES_ORDERS,
        [
          () => {
            dispatch(loadAccessoriesOrders(params, false));
            return {'type': ActionTypes.GENERATED_ACCESSORIES_ORDERS};
          },
          MessageActions.addMessageBoxInfo('Ordenes generadas satisfactoriamente'),
        ],
        [
          ActionTypes.GENERATED_ACCESSORIES_ORDERS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': {...data},
    }),
  );
};

export const printAccessoriesOrders = (date) => apiActionCreator({
  'endpoint': `/accessories/orders/documents?date=${date}`,
  'authenticated': true,
  'types': [
    ActionTypes.PRINTING_ACCESSORIES_ORDERS,
    ActionTypes.PRINTED_ACCESSORIES_ORDERS,
    [
      ActionTypes.PRINTED_ACCESSORIES_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const cancelOrder = (order, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/accessories/orders/${order}/cancel`,
      'authenticated': true,
      'types': [
        ActionTypes.CANCELLING_ORDER,
        [
          () => {
            if (data.type !== 'qualityAssurance') {
              const params = {
                'date': data.date,
                'type': data.type,
                'chassis': data.chassis,
                'invoiceType': data.invoiceType,
              };
              dispatch(loadAccessoriesOrders(params, false));
            }
            return {'type': ActionTypes.CANCELLED_ORDER};
          },
          MessageActions.addMessageBoxInfo(`La orden ${order} ha sido anulada satisfactoriamente`),
        ],
        [
          ActionTypes.CANCELLED_ORDER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],

      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      data,
    }),
  );
};

export const restoreAccessoriesOrdersPage = () => ({
  'type': ActionTypes.RESTORE_ACCESSORIES_ORDERS_PAGE,
});

export const cleanAccessoriesOrderList = () => ({
  'type': ActionTypes.CLEAN_ACCESSORIES_ORDERS_LIST,
});

export const changeAccessoriesOrdersDate = (date) => ({
  'type': ActionTypes.CHANGE_ACCESSORIES_ORDERS_DATE,
  'payload': date,
});

export const changeAccessoriesOrdersDateEnd = (date) => ({
  'type': ActionTypes.CHANGE_ACCESSORIES_ORDERS_DATE_END,
  'payload': date,
});

export const changeAccessoriesOrdersPage = (page) => ({
  'type': ActionTypes.CHANGE_ACCESSORIES_ORDERS_PAGE,
  'payload': page,
});

export const resizeAccessoriesOrdersPage = (size) => ({
  'type': ActionTypes.RESIZE_ACCESSORIES_ORDERS_PAGE,
  'payload': size,
});

export const changeChassisMarked = (chassis) => ({
  'type': ActionTypes.CHANGE_CHASSIS_MARKED,
  'payload': chassis,
});

export const changeOrdersMarked = (orders) => ({
  'type': ActionTypes.CHANGE_ORDERS_MARKED,
  'payload': orders,
});
